import axios from "axios";

const ENDPOINT_KEY = "purchase";
const ENDPOINT_URI = "/purchase";

export default function usePurchaseService() {
  return {
    queryKey: ENDPOINT_KEY,
    getPurchases: async (
      search = "",
      from = "",
      to = "",
      page = 1,
      limit = 10,
    ) => {
      const params = new URLSearchParams({
        page,
        limit,
      });
      if (search) {
        params.append("search", search);
      }
      if (from) {
        params.append("from", from);
      }
      if (to) {
        params.append("to", to);
      }
      const response = await axios.get(`${ENDPOINT_URI}/`, {
        params,
      });
      return response.data.payload;
    },
    getPurchaseById: async (id) => {
      const response = await axios.get(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    addNewPurchase: async ({ payload }) => {
      const response = await axios.post(`${ENDPOINT_URI}/`, payload);
      return response.data.payload;
    },
  };
}
